import { HStack, StackProps, useMultiStyleConfig } from "@chakra-ui/react";
import { forwardRef, PropsWithChildren } from "react";

export const RadioStack = forwardRef<
	HTMLDivElement,
	PropsWithChildren<StackProps>
>(({ children, ...rest }, ref) => {
	const styles = useMultiStyleConfig("RadioStack");

	return (
		<HStack ref={ref} sx={styles.container} {...rest}>
			{children}
		</HStack>
	);
});

RadioStack.displayName = "RadioStack";

// 🔬 skip
